var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCriticalSeverity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A critical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.01590437,0.0519185952 C9.14149362,0.12714639 9.24656609,0.232218865 9.32179389,0.35780811 L17.0539892,13.2663423 C17.3063417,13.687633 17.1693903,14.2337288 16.7480996,14.4860814 C16.6100349,14.568782 16.4521135,14.612461 16.2911749,14.612461 L0.826784333,14.612461 C0.335696078,14.612461 -0.0624096108,14.2143553 -0.0624096108,13.7232671 C-0.0624096108,13.5623284 -0.0187305399,13.4044071 0.0639700517,13.2663423 L7.79616532,0.35780811 C8.0485179,-0.0634825843 8.59461368,-0.200433985 9.01590437,0.0519185952 Z M8.46209072,10.7304272 C7.92698819,10.7304272 7.49320188,11.1649387 7.49320188,11.7009357 C7.49320188,12.2369327 7.92698819,12.6714441 8.46209072,12.6714441 C8.99719325,12.6714441 9.43097957,12.2369327 9.43097957,11.7009357 C9.43097957,11.1649387 8.99719325,10.7304272 8.46209072,10.7304272 Z M7.51949165,4.72781258 C7.51949165,5.78464328 7.70535883,8.30547776 7.70535883,9.23961399 C7.70535883,10.1737502 9.19039654,10.2686357 9.19039654,9.23961399 C9.19039654,8.21059233 9.41969747,5.78464328 9.41969747,4.72781258 C9.41969747,3.67098187 7.51949165,3.67098187 7.51949165,4.72781258 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Investigations-small-screen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.000000, -293.000000)",
    id: "A-critical"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.528793, 293.714561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3-+-Oval-Mask",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalSeverity);
export default __webpack_public_path__ + "static/media/critical-severity.d72f4594ce9ed8192aec33b2cb96d0e6.svg";
export { ForwardRef as ReactComponent };